module.exports = __webpack_public_path__ + "static/media/mall-discount.caba1d69.svg";